export const QueryKeys = {
    GetAllCounterpartiesQuery: 'get-all-counterparties',
    GetAllCounterpartiesQueryOptions: 'get-all-counterparties-options',
    GetCounterpartyByIdQuery: 'get-counterparty-by-id',
}
